import { mergeQueryKeys } from '@lukemorales/query-key-factory';

import { 코너로지스_고객정보_쿼리 } from '@/app/manager/shop-list/services/query-keys';
import { 플랫폼_쿼리키 } from '@/app/settings/platform-linkage/services/query-keys';

import { 원스톱_솔루션_상품_쿼리 } from './one-stop-solution/상품목록/services/query-keys';
import { 코너로지스_상품_반출_쿼리 } from './one-stop-solution/상품반출/services/query-keys';
import { 코너로지스_상품_폐기_쿼리 } from './one-stop-solution/상품폐기/services/query-keys';
import { 원스톱_솔루션_입고_쿼리 } from './one-stop-solution/입고신청/services/query-keys';
import { 원스톱_솔루션_정산_쿼리 } from './one-stop-solution/정산내역/services/query-keys';
import { 코너로지스_주문_쿼리 } from './one-stop-solution/주문출고_반품신청/services/query-keys';
import { 원스톱_솔루션_패키지_쿼리 } from './one-stop-solution/패키지목록/services/query-keys';
import { 샵_정보_쿼리키 } from './shop/services/query-keys';

export const queries = mergeQueryKeys(
  샵_정보_쿼리키,
  원스톱_솔루션_입고_쿼리,
  원스톱_솔루션_패키지_쿼리,
  코너로지스_주문_쿼리,
  원스톱_솔루션_상품_쿼리,
  원스톱_솔루션_정산_쿼리,
  코너로지스_상품_반출_쿼리,
  코너로지스_상품_폐기_쿼리,
  코너로지스_고객정보_쿼리,
  플랫폼_쿼리키,
);
